import { TrainingStatusEnum } from '@geartracker/types';

import { createZodDto } from './zod';

import { z } from 'zod';

export const CreateUpdateTrainingSchema = z
  .object({
    name: z.string().min(1),
    description: z.string().nullable(),
    date: z.coerce.date(),
    expiryDate: z.coerce.date().nullable(),
    userId: z.number().int(),
    status: z.nativeEnum(TrainingStatusEnum),
    filesIds: z.number().array().default([]),
  })
  .refine(
    (data) => {
      if (!data.expiryDate) return true;
      return data.expiryDate > data.date;
    },
    {
      message: 'Expiry date must be after training date',
      path: ['expiryDate'],
    },
  );

export class TrainingCreateUpdateDto extends createZodDto(
  CreateUpdateTrainingSchema,
) {}
